<template>
    <img :style="'transform: rotate(' + rotate + 'deg);'" class="question-sticker" :class="[ 'positionX-' + positionX, 'positionY-' + positionY, 'bleed-' + bleed ]" :src="'/question_assets/' + fileName" />
</template>

<script>
export default {
    name: 'QuestionSticker',
    props: {
        positionX: String,
        positionY: String,
        bleed: Boolean,
        fileName: String,
        rotate: Number
    }
}
</script>